<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("menu.trans") }}
          </h6>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="handleCreate()">{{
            $t("new")
          }}</base-button>

		<router-link :to="{name:'TransCancel'}">
		  <base-button size="md" type="neutral">{{
            $t("menu.trans_cancel")
          }}</base-button>
		</router-link>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ $t("menu.trans") }}</h3>

            <!-- Filter panel — two rows with labels + right-aligned actions -->
            <div class="trans-filters mt-3">
              <!-- Row 1 — primary filters: date range, policy number, insurance -->
              <div class="row">
                <div class="col-md-2">
                  <base-input :label="$t('lmg.start_date')">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      v-model="searchParams.startDate"
                    >
                    </flat-picker>
                  </base-input>
                </div>

                <div class="col-md-2">
                  <base-input :label="$t('lmg.end_date')">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      v-model="searchParams.endDate"
                    >
                    </flat-picker>
                  </base-input>
                </div>

                <div class="col-md-4">
                  <base-input
                    :label="$t('lmg.policy_number')"
                    v-model="searchParams.policyNumber"
                    :placeholder="$t('lmg.policy_number')"
                  ></base-input>
                </div>

                <div class="col-md-4">
                  <base-input :label="$t('lmg.insure')">
                    <el-select
                      v-model="searchParams.insuranceID"
                      :placeholder="$t('lmg.insure')"
                      filterable
                    >
                      <el-option
                        v-for="option in tableInsureWithAll"
                        :key="option.ID"
                        :label="option.Name"
                        :value="option.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>
              </div>

              <!-- Row 2 — secondary filters + actions -->
              <div class="row">
                <div class="col-md-3">
                  <base-input :label="$t('lmg.owner_person')">
                    <el-select
                      v-model="searchParams.ownerPersonID"
                      :placeholder="$t('lmg.owner_person')"
                      filterable
                    >
                      <el-option
                        v-for="option in tablePersonDropdownWithAll"
                        :key="option.ID"
                        :label="(option.FName + ' ' + option.LName).trim()"
                        :value="option.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>

                <div class="col-md-2">
                  <base-input :label="$t('status')">
                    <el-select
                      v-model="searchParams.status"
                      :placeholder="$t('status')"
                    >
                      <el-option
                        v-for="option in status"
                        :key="option.ID"
                        :label="option.Name"
                        :value="option.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>

                <div class="col-md-2">
                  <base-input :label="$t('lmg.cash_clear')">
                    <el-select
                      v-model="searchParams.cashClear"
                      :placeholder="$t('lmg.cash_clear')"
                    >
                      <el-option
                        v-for="option in cashClear"
                        :key="option.ID"
                        :label="option.Name"
                        :value="option.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>

                <div class="col-md-2">
                  <base-input :label="$t('lmg.sort')">
                    <el-select
                      v-model="searchParams.sort"
                      :placeholder="$t('lmg.sort')"
                    >
                      <el-option
                        v-for="option in sort"
                        :key="option.ID"
                        :label="option.Name"
                        :value="option.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>

                <div class="col-md-3 d-flex align-items-end justify-content-end flex-wrap trans-filter-actions">
                  <base-button
                    size="md"
                    type="primary"
                    class="mr-1 mb-2"
                    :disabled="isLoading"
                    @click="listData(searchParams)"
                  >
                    <i class="fas fa-spinner fa-spin mr-1" v-if="isLoading"></i>
                    <i class="fas fa-search mr-1" v-else></i>
                    {{ $t("search") }}
                  </base-button>

                  <base-button
                    size="md"
                    type="secondary"
                    class="mr-1 mb-2"
                    :disabled="isLoading"
                    @click="handleResetFilters()"
                  >
                    <i class="fas fa-undo mr-1"></i>
                    {{ $t("clear") }}
                  </base-button>

                  <base-button
                    size="md"
                    type="neutral"
                    class="mr-1 mb-2"
                    @click="handleExportCSV()"
                    v-if="tableData.length > 0"
                  >
                    <i class="fas fa-file-csv mr-1"></i>
                    CSV
                  </base-button>

                  <base-button
                    size="md"
                    type="success"
                    class="mb-2"
                    @click="handleExportXLSX()"
                    v-if="tableData.length > 0"
                  >
                    <i class="fas fa-file-excel mr-1"></i>
                    XLSX
                  </base-button>
                </div>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column :label="$t('lmg.ttype')" min-width="150">
                <template slot-scope="{ row }">
                  {{ row.TransactionTypeName }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('lmg.owner_person')" min-width="200">
                <template slot-scope="{ row }">
                  {{ row.OwnerPersonFName }} {{ row.OwnerPersonLName }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('lmg.customer')" min-width="200">
                <template slot-scope="{ row }">
                  {{ row.CustomerFname }} {{ row.CustomerLname }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('lmg.policy_number')" min-width="200">
                <template slot-scope="{ row }">
                  {{ row.PolicyNumber }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('lmg.protection_date')" min-width="200">
                <template slot-scope="{ row }">
                  {{ row.StartDateShow }} - {{ row.EndDateShow }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('lmg.amount')" min-width="150">
                <template slot-scope="{ row }">
					<span v-if="row.MoreDiscount > 0" class="text-red">{{ FormatCurrency(row.Amount) }}</span>
					<span v-else>{{ FormatCurrency(row.Amount) }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('lmg.discount')" min-width="150">
                <template slot-scope="{ row }">
                  {{ FormatCurrency(row.CommissionAmount) }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('status')" min-width="150">
                <template slot-scope="{ row }">
                  <template v-if="row.Status == 1">สำเร็จ</template>
                  <template v-if="row.Status == 2">กำลังดำเนินการ</template>
                  <template v-if="row.Status == 3">ยกเลิก</template>
                </template>
              </el-table-column>

              <!-- <el-table-column :label="$t('lmg.comm')">
                <template slot-scope="{ row }">
                  {{ row.ComProfileName }}
                </template>
              </el-table-column> -->

              <el-table-column :label="$t('lmg.sale_date')" min-width="150">
                <template slot-scope="{ row }">
                  {{ row.SaleDateShow }}
                </template>
              </el-table-column>

              <el-table-column align="right" :label="$t('actions')" min-width="230">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click.native="handleReport(row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                    title="รายงาน"
                  >
                    <i class="text-dtac-bt fa fa-file"></i>
                  </base-button>

                  <base-button
                    @click.native="handleDetail(row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                    title="รายละเอียด"
                  >
                    <i class="text-dtac-bt fa fa-list"></i>
                  </base-button>

                  <base-button
                    @click.native="handlePaymentTable($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    title="รายการชำระเงิน"
                    icon
                  >
                    <i class="fas fa-dollar-sign"></i>
                  </base-button>

                  <base-button
                    @click.native="handleBilling($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                    v-if="row.HasBilling != 0"
                    title="รายการเรียกเก็บเงิน"
                  >
                    <i class="fas fa-file-invoice-dollar"></i>
                  </base-button>

                  <!-- <base-button
                    @click.native="handleTransactionPayment($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                    v-if="row.Status == 2"
                    title="ชำระเงิน"
                  >
                    <i class="fa fa-money-check"></i>
                  </base-button> -->

                  <!-- <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-trash"></i>
                  </base-button> -->
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="tableData.length != 0"
          >
            <div class="กำลังดำเนินการ">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <!-- ------------------------ Modal Create ------------------------ -->
    <modal
      :show.sync="showCreateModal"
      modal-classes="modal-secondary modal-lg"
    >
      <h1>{{ $t("lmg.trans_create") }}</h1>

      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form role="form" @submit.prevent="handleSubmit(handleCreateRequest)">
          <!-- *** person  comm payment -->
          <div class="row">
            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.sale_date')"
                :name="$t('lmg.sale_date')"
                rules="required"
              >
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true }"
                  class="form-control datepicker"
                  v-model="trans.saleDate"
                >
                </flat-picker>
              </base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.ttype')"
                :name="$t('lmg.ttype')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="ttype"
                  :placeholder="$t('lmg.ttype')"
                  filterable
                >
                  <el-option
                    v-for="option in tableTtype"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.owner_person')"
                :name="$t('lmg.owner_person')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.ownerPersonID"
                  :placeholder="$t('lmg.owner_person')"
                  filterable
                >
                  <el-option
                    v-for="option in tablePersonFilter"
                    :key="option.ID"
                    :label="option.FName + ' ' + option.LName"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-lg-4">
              <base-input
                :label="$t('lmg.insure')"
                :name="$t('lmg.insure')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.insuranceID"
                  :placeholder="$t('lmg.insure')"
                  filterable
                >
                  <el-option
                    v-for="option in tableInsure"
                    :key="option.ID"
                    :label="option.ShowName"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.trans_amount')"
                :name="$t('lmg.trans_amount')"
                v-model="trans.amount"
                rules="required"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.summary_amount')"
                :name="$t('lmg.summary_amount')"
                v-model="trans.amountAll"
                rules="required"
              ></base-input>
            </div>

			  <div class="col-lg-3">
              <base-input
                :label="getTaxPercent"
                v-model="trans.taxAmount"
                :name="getTaxPercent"
                rules="required"
              >
              </base-input>
            </div>


            
            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.whTax')"
                v-model="trans.whTax"
                :name="$t('lmg.whTax')"
              >
              </base-input>
            </div>

            

            <div class="col-lg-3">
              <base-input
                :label="getCommissionPercent"
                v-model="trans.commisionAmount"
                :name="getCommissionPercent"
                rules="required"
              >
              </base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.net_amount')"
                v-model="trans.netAmount"
                :name="$t('lmg.net_amount')"
                rules="required"
              >
              </base-input>
            </div>

          <div class="col-lg-2">
              <base-input
                :label="$t('lmg.moreDiscount')"
                v-model="trans.moreDiscount"
                :name="$t('lmg.moreDiscount')"
              >
              </base-input>
              <!-- <base-input
                :label="$t('lmg.moreDiscount')"
                v-model="trans.moreDiscount"
                :name="$t('lmg.moreDiscount')"
                disabled
                v-if="(trans.payAmount == trans.initialPayment)"
              >
              </base-input>
              <base-input
                :label="$t('lmg.moreDiscount')"
                v-model="trans.moreDiscount"
                :name="$t('lmg.moreDiscount')"
                :rules="{required : true , max_value: (trans.payAmount - trans.initialPayment), min_value: 0}"
                v-if="(trans.payAmount != trans.initialPayment) && trans.initialPayment == 0"
              >
              </base-input>
              <base-input
                :label="$t('lmg.moreDiscount')"
                v-model="trans.moreDiscount"
                :name="$t('lmg.moreDiscount')"
                :rules="{required : true , max_value: (trans.payAmount - trans.initialPayment), min_value: (trans.payAmount - trans.initialPayment)}"
                v-if="(trans.payAmount != trans.initialPayment) && trans.initialPayment != 0"
              >
              </base-input> -->
            </div>

			<div class="col-lg-2">
              <base-input
                :label="$t('lmg.extra_charge')"
                v-model="trans.extraCharge"
                :name="$t('lmg.extra_charge')"
                rules="required"
              >
              </base-input>
            </div>

            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.pay_amount')"
                v-model="trans.payAmount"
                :name="$t('lmg.pay_amount')"
                rules="required"
              >
              </base-input>
            </div>
          </div>



		   <div class="row">
			<div class="col-lg-2">
              <base-input
                :label="$t('lmg.comm_incentive')"
                v-model="trans.incentive"
                :name="$t('lmg.comm_incentive')"
              >
              </base-input>
            </div>
            <!-- <div class="col-lg-2" v-if="trans.initialPaymentVia != 4 && trans.initialPayment != trans.amount"> -->
            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.billing_period')"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.nBilling"
                  :placeholder="$t('lmg.billing_period')"
                >
                  <el-option
                    v-for="option in billingPeriod"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-lg-3" v-if="trans.nBilling == 3">
              <base-input
                :label="$t('lmg.billCharge')"
                :name="$t('lmg.billCharge')"
                rules="required"
                v-model="trans.billCharge"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.renew')"
                :name="$t('lmg.renew')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select v-model="trans.renew" :placeholder="$t('lmg.renew')">
                  <el-option
                    v-for="option in renewTable"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-lg-3" v-if="trans.renew == 2">
              <base-input
                :label="$t('lmg.policyNumberUpper')"
                :name="$t('lmg.policyNumberUpper')"
                rules="required"
                v-model="trans.policyNumberUpper"
              ></base-input>
            </div>
          </div>

          <div class="row">
            <!-- <div class="col-lg-3">
              <base-input
                :label="$t('lmg.payment_comm')"
                :name="$t('lmg.payment_comm')"
                rules="required"
                v-model="trans.initialCom"
              ></base-input>
            </div> -->
            <!-- <div class="col-lg-3">
              <base-input
                :label="$t('lmg.payment_amount')"
                :name="$t('lmg.payment_amount')"
                :rules="{required : true , max_value: trans.payAmount}"
                v-model="trans.initialPayment"
              ></base-input>
            </div> -->

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.payment_method')"
                :name="$t('lmg.payment_method')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.initialPaymentVia"
                  :placeholder="$t('lmg.payment_method')"
                >
                  <el-option
                    v-for="option in paymentType"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

			<div class="col-lg-3" v-if="trans.initialPaymentVia == 3">
              <base-input
                :label="$t('lmg.bank')"
                :name="$t('lmg.bank')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.paymentBankID"
                  :placeholder="$t('lmg.bank')"
                >
                  <el-option
                    v-for="option in tableBank"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-lg-6">
              <base-input
                :label="$t('lmg.paid_file')"
                input-classes="form-control-alternative new-event--title"
              >
                <file-input @change="filesChange"></file-input>
              </base-input>
            </div>

		  </div>

		 

          <!-- initialcom  initilpayment initial via -->

          <div class="row">
            
          </div>

		  <div class="row">
			<div class="col-lg-12">
              <base-input
                :label="$t('lmg.note')"
                :name="$t('lmg.note')"
                v-model="trans.note"
              ></base-input>
            </div>
		  </div>

          <div class="row">
            <div class="col-lg-5" v-if="trans.commCalculate != ''">
              <div class="form-group">
                <label class="form-control-label"></label>

                <div class="has-label">
                  <label class="form-control-label"
                    >{{ $t("lmg.comm_amount") }}ที่คำนวณได้
                    {{ trans.commCalculate }} บาท
                  </label>
                </div>
              </div>

              <!-- <base-input :label="$t('lmg.comm_amount')" v-model="trans.commCalculate"  :name="$t('lmg.comm_amount')"> -->
              <!-- </base-input> -->
            </div>
          </div>

          <hr />

          <!-- LINE 1 -->
          <!-- InsuranceYear -->
          <div class="row">
            <!-- <div class="col-lg-4">
              <base-input
                :label="$t('lmg.insure_year')"
                v-model="trans.insuranceYear"
                rules="required"
                :name="$t('lmg.insure_year')"
              ></base-input>
            </div>

            <div class="col-lg-4">
              <base-input
                :label="$t('lmg.trans_detail')"
                v-model="trans.detail"
                rules="required"
                :name="$t('lmg.trans_detail')"
              ></base-input>
            </div> -->

            <div class="col-lg-12">
              <base-input
                :label="$t('lmg.policy_number')"
                :name="$t('lmg.policy_number')"
                rules="required"
                v-model="trans.policyNumber"
              ></base-input>
            </div>
          </div>

          <!-- LINE 2 -->
          <div class="row">
            <div class="col-lg-4">
              <base-input
                :label="$t('lmg.card_type')"
                :name="$t('lmg.card_type')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.idCardType"
                  :placeholder="$t('lmg.card_type')"
                >
                  <el-option
                    v-for="option in idCardType"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-lg-8">
              <base-input
                :label="$t('lmg.cid')"
                v-model="trans.customerCardNumber"
                rules="required"
                :name="$t('lmg.cid')"
              ></base-input>
            </div>
          </div>

          <!-- LINE 3  customer pfix  fname  lname -->
          <div class="row">
            <div class="col-lg-3">
              <base-input
                :label="$t('profile.pname')"
                :name="$t('profile.pname')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.customerPrefix"
                  :placeholder="$t('profile.pname')"
                >
                  <el-option
                    v-for="option in tablePname"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-lg-6" v-if="trans.idCardType == 3">
              <base-input
                :label="$t('profile.fname')"
                :name="$t('profile.fname')"
                rules="required"
                v-model="trans.customerFname"
              ></base-input>
            </div>
            <div class="col-lg-3" v-if="trans.idCardType != 3">
              <base-input
                :label="$t('profile.fname')"
                :name="$t('profile.fname')"
                rules="required"
                v-model="trans.customerFname"
              ></base-input>
            </div>
            <div class="col-lg-3" v-if="trans.idCardType != 3">
              <base-input
                :label="$t('profile.lname')"
                :name="$t('profile.lname')"
                rules="required"
                v-model="trans.customerLname"
              ></base-input>
            </div>
            

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.tel')"
                :name="$t('lmg.tel')"
                rules="required"
                v-model="trans.customerTel"
              ></base-input>
            </div>
          </div>


<!-- Address -->
		  <div class="row">

			 <div class="col-lg-3">
              <base-input
                :label="$t('lmg.address_customer')"
                :name="$t('lmg.address_customer')"
                rules="required"
                v-model="trans.customerAddress"
              ></base-input>
            </div>

			<!-- Province -->
			<div class="col-lg-2">
              <base-input
                :label="$t('lmg.address_province')"
                :name="$t('lmg.address_province')"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.customerProvinceID"
                  :placeholder="$t('lmg.address_province')"
				  @change="handleProviceChange()"
				  filterable
                >
                  <el-option
                    v-for="option in ProvinceTable"
                    :key="option.code"
                    :label="option.name_th"
                    :value="option.code"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

			<!-- District -->
			<div class="col-lg-2" v-if="trans.customerProvinceID != 0 && trans.customerProvinceID!= ''">
              <base-input
                :label="$t('lmg.address_district')"
                :name="$t('lmg.address_district')"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.customerDistrictID"
                  :placeholder="$t('lmg.address_district')"
				  @change="handleDistrictChange()"
				  filterable
                >
                  <el-option
                    v-for="option in DistrictTable"
                    :key="option.code"
                    :label="option.name_th"
                    :value="option.code"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

			<div class="col-lg-2" v-if="trans.customerDistrictID != 0 && trans.customerDistrictID!= ''">
              <base-input
                :label="$t('lmg.address_subdistrict')"
                :name="$t('lmg.address_subdistrict')"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.customerSubDistrictID"
                  :placeholder="$t('lmg.address_subdistrict')"
				  @change="handleSubDistrictChange()"
				  filterable
                >
                  <el-option
                    v-for="option in SubDistrictTable"
                    :key="option.code"
                    :label="option.name_th"
                    :value="option.code"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>


			<div class="col-lg-3" v-if="trans.customerSubDistrictID != 0 && trans.customerSubDistrictID!= ''">
              <base-input
                :label="$t('lmg.address_zipcode')"
                :name="$t('lmg.address_zipcode')"
                rules="required"
                v-model="trans.customerPostCode"
              ></base-input>
            </div>


		  </div>

	


          <!-- LINE 4 customer gender  dateofbirth -->
          <div class="row">
            <div class="col-lg-2">
              <base-input
                :label="$t('profile.gender')"
                :name="$t('profile.gender')"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.customerGender"
                  :placeholder="$t('profile.gender')"
                >
                  <el-option
                    v-for="option in gender"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-lg-2">
              <base-input
                :label="$t('profile.birthday')"
                :name="$t('profile.birthday')"
              >
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true }"
                  class="form-control datepicker"
                  v-model="trans.customerDateOfBirth"
                >
                </flat-picker>
              </base-input>
            </div>

            <div class="col-lg-5">
              <base-input
                :label="$t('email')"
                :name="$t('email')"
                v-model="trans.customerEmail"
              ></base-input>
            </div>
          </div>

          <!-- LINE 5 - dataType 1 -->
          <div class="row" v-if="trans.transactionDataType == 1">
            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.car_model')"
                :name="$t('lmg.car_model')"
                rules="required"
                v-model="trans.carModel"
              ></base-input>
            </div>

            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.chassis_number')"
                :name="$t('lmg.chassis_number')"
                rules="required"
                v-model="trans.chassisNumber"
              ></base-input>
            </div>

            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.license_plate')"
                :name="$t('lmg.license_plate')"
                rules="required"
                v-model="trans.licencePlate"
              ></base-input>
            </div>

            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.car_year')"
                :name="$t('lmg.car_year')"
                rules="required"
                v-model="trans.carRegisterYear"
              ></base-input>
            </div>

            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.insure_sum')"
                :name="$t('lmg.insure_sum')"
                rules="required"
                v-model="trans.sumInsured"
              ></base-input>
            </div>

			<div class="col-lg-2">
              <base-input
                :label="$t('lmg.car_type')"
                :name="$t('lmg.car_type')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="trans.engine"
                  :placeholder="$t('lmg.car_type')"
                >
                  <el-option
                    v-for="option in carType"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
			</div>

          </div>

          <!-- LINE 5 - dataType 2 -->
          <div class="row" v-if="trans.transactionDataType == 2">
            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.insure_type')"
                :name="$t('lmg.insure_type')"
                rules="required"
                v-model="trans.insuranceTypeDesc"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.insure_plan')"
                :name="$t('lmg.insure_plan')"
                rules="required"
                v-model="trans.insurancePlan"
              ></base-input>
            </div>

            <div class="col-lg-1">
              <base-input
                :label="$t('lmg.age')"
                :name="$t('lmg.age')"
                rules="required"
                v-model="trans.customerAge"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.detail')"
                v-model="trans.detail"
                rules="required"
              ></base-input>
            </div>

            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.insure_sum')"
                :name="$t('lmg.insure_sum')"
                rules="required"
                v-model="trans.sumInsured"
              ></base-input>
            </div>
          </div>

          <!-- LINE 5 - dataType 3 -->
          <div class="row" v-if="trans.transactionDataType == 3">
            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.insure_type')"
                :name="$t('lmg.insure_type')"
                rules="required"
                v-model="trans.insuranceTypeDesc"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.billing_address')"
                :name="$t('lmg.billing_address')"
                rules="required"
                v-model="trans.buildingAddress"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.code_disaster')"
                :name="$t('lmg.code_disaster')"
                rules="required"
                v-model="trans.codeDisaster"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.insure_sum')"
                :name="$t('lmg.insure_sum')"
                rules="required"
                v-model="trans.sumInsured"
              ></base-input>
            </div>
          </div>

          <!-- LINE 5 - dataType 4 -->
          <div class="row" v-if="trans.transactionDataType == 4">
            <div class="col-lg-2">
              <base-input
                :label="$t('lmg.car_model')"
                :name="$t('lmg.car_model')"
                rules="required"
                v-model="trans.carModel"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.chassis_number')"
                :name="$t('lmg.chassis_number')"
                rules="required"
                v-model="trans.chassisNumber"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.license_plate')"
                :name="$t('lmg.license_plate')"
                rules="required"
                v-model="trans.licencePlate"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.insurance_scope')"
                :name="$t('lmg.insurance_scope')"
                rules="required"
                v-model="trans.insuranceScope"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.insure_sum')"
                :name="$t('lmg.insure_sum')"
                rules="required"
                v-model="trans.sumInsured"
              ></base-input>
            </div>
          </div>

          <!-- LINE 5 - dataType 4 -->
          <div class="row" v-if="trans.transactionDataType == 5">
            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.insure_type')"
                :name="$t('lmg.insure_type')"
                rules="required"
                v-model="trans.insuranceTypeDesc"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.insure_plan')"
                :name="$t('lmg.insure_plan')"
                rules="required"
                v-model="trans.insurancePlan"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.note')"
                v-model="trans.detail"
              ></base-input>
            </div>

            <div class="col-lg-3">
              <base-input
                :label="$t('lmg.insure_sum')"
                :name="$t('lmg.insure_sum')"
                rules="required"
                v-model="trans.sumInsured"
              ></base-input>
            </div>
          </div>

          <!-- LINE 7 cover start - end -->
          <div class="row">
            <div class="col-lg-4">
              <base-input
                :label="$t('lmg.policy_start_date')"
                :name="$t('lmg.policy_start_date')"
                rules="required"
              >
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true }"
                  :rules="{ required: true }"
                  class="form-control datepicker"
                  v-model="trans.startDate"
                >
                </flat-picker>
              </base-input>
            </div>
            <div class="col-lg-4">
              <base-input
                :label="$t('lmg.policy_end_date')"
                :name="$t('lmg.policy_end_date')"
                rules="required"
              >
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true }"
                  :rules="{ required: true }"
                  class="form-control datepicker"
                  v-model="trans.endDate"
                >
                </flat-picker>
              </base-input>
            </div>
          </div>

          <br />
          <div class="row">
            <div class="col-lg-6">
              <button type="submit" class="btn btn-md btn-primary">
                {{ $t("save") }}
              </button>
              <button
                type="submit"
                @click="handleSaveContinue()"
                class="btn btn-md btn-primary"
                v-if="showSaveContinue == true"
              >
                {{ $t("save_continue") }}
              </button>
            </div>

            <div class="col-lg-6 text-right">
              <button
                type="button"
                class="btn btn-md btn-link ml-auto"
                @click="
                  clearCreate();
                  showCreateModal = false;
                "
              >
                {{ $t("close") }}
              </button>
            </div>
          </div>
        </form>
      </validation-observer>
    </modal>

    <!-- ------------------------  Modal Detail  ------------------------ -->
    <modal
      :show.sync="showDetailModal"
      modal-classes="modal-secondary modal-lg"
    >
	<div class="trans-detail">
	<div class="detail-header">
		<div>
			<h4>
				<i class="fas fa-file-invoice mr-2"></i>{{ $t("lmg.trans_detail") }}
				<span class="detail-id">#{{ detail.ID }}</span>
			</h4>
		</div>
		<div class="d-flex align-items-center">
			<span class="status-pill status-pill--danger mr-2" v-if="detail.Cancel==1">
				<i class="fas fa-ban"></i>ยกเลิก
			</span>
			<base-button
				v-if="detail.Cancel==0"
                @click.native="handleCancelTransaction()"
                class="edit"
                type="warning"
                size="sm"
                icon
              >
                <i class="fas fa-trash"></i>
					{{ $t("lmg.cancel_trans")}}
              </base-button>
		</div>
	</div>

      <!-- SECTION: Transaction Info -->
      <div class="detail-section">
        <div class="detail-section-header"><i class="fas fa-info-circle"></i>ข้อมูลรายการ</div>
      <!-- recorder owner person customer -->
      <div class="row">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.sale_date')"
            :value="detail.SaleDateShow"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.recorder')"
            :value="detail.RecordPersonFName + '  ' + detail.RecordPersonLName"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.owner_person')"
            :value="detail.OwnerPersonFName + '  ' + detail.OwnerPersonLName"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.customer')"
            :value="detail.CustomerFname + '  ' + detail.CustomerLname"
          ></base-input>
        </div>
      </div>
      </div> <!-- /Section: Transaction Info -->

      <!-- SECTION: Customer Address -->
      <div class="detail-section">
        <div class="detail-section-header"><i class="fas fa-map-marker-alt"></i>ที่อยู่ลูกค้า</div>
	  <div class="row">
		<div class="col-lg-4">
          <base-input
            :label="$t('lmg.address_customer')"
            :value="detail.CustomerAddress"
          ></base-input>
        </div>

		<div class="col-lg-2">
          <base-input
            :label="$t('lmg.address_subdistrict')"
            :value="detail.CustomerSubDistrict"
          ></base-input>
        </div>

		<div class="col-lg-2">
          <base-input
            :label="$t('lmg.address_district')"
            :value="detail.CustomerDistrict"
          ></base-input>
        </div>

		<div class="col-lg-2">
          <base-input
            :label="$t('lmg.address_province')"
            :value="detail.CustomerProvince"
          ></base-input>
        </div>

		<div class="col-lg-2">
          <base-input
            :label="$t('lmg.address_zipcode')"
            :value="detail.CustomerPostCode"
          ></base-input>
        </div>

	  </div>
      </div> <!-- /Section: Customer Address -->

      <!-- SECTION: Insurance & Financial -->
      <div class="detail-section detail-section--financial">
        <div class="detail-section-header"><i class="fas fa-coins"></i>ประกันและการเงิน</div>

      <div class="row">
        <div class="col-lg-12">
          <base-input
            :label="$t('lmg.insure')"
            :value="detail.InsuranceShowName"
          ></base-input>
        </div>
	  </div>


	  <div class="row">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.trans_amount')"
            :value="detail.Amount"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.summary_amount')"
            :value="detail.AmountAll"
          ></base-input>
        </div>

		<div class="col-lg-3">
          <base-input
            :label="$t('lmg.tax_amount')"
            :value="detail.TaxAmount"
          ></base-input>
        </div>
       

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.whTax')"
            :value="detail.WhTax"
            :name="$t('lmg.whTax')"
            rules="required|numeric"
          >
          </base-input>
        </div>
	  </div>

	<div class="row">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.discount')"
            :value="detail.CommissionAmount"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.net_amount')"
            :value="detail.NetAmount"
          ></base-input>
        </div>

		<div class="col-lg-2">
			<base-input
			:label="$t('lmg.moreDiscount')"
			:value="detail.MoreDiscount"
			:name="$t('lmg.moreDiscount')"
			>
			</base-input>
		</div>

		<div class="col-lg-2">
              <base-input
                :label="$t('lmg.extra_charge')"
                v-model="detail.ExtraCharge"
                :name="$t('lmg.extra_charge')"
              >
              </base-input>
		</div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.pay_amount')"
            :value="detail.PayAmount"
          ></base-input>
        </div>
	</div>
	<div class="row">
		<div class="col-lg-2">
          <base-input
            :label="$t('lmg.comm_incentive')"
            :value="detail.Incentive"
            :name="$t('lmg.comm_incentive')"
            rules="required|numeric"
          >
          </base-input>
        </div>


        <!-- <div class="col-lg-3">
          <base-input
            :label="$t('lmg.payment_amount')"
            :value="detail.InitialPayment"
          ></base-input>
        </div> -->

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.payment_comm')"
            :value="detail.InitialCom"
          ></base-input>
        </div>

		

      </div>

      <div class="row">
        <div class="col-lg-6">
          <base-input
            :label="$t('lmg.ttype')"
            :value="detail.TransactionTypeName"
          ></base-input>
        </div>

        <div class="col-lg-6">
          <base-input
            :label="$t('lmg.comm')"
            :value="detail.ComProfileName"
          ></base-input>
        </div>
      </div>
      </div> <!-- /Section: Insurance & Financial -->

      <!-- SECTION: Policy & Product Detail -->
      <div class="detail-section">
        <div class="detail-section-header"><i class="fas fa-file-contract"></i>กรมธรรม์และรายละเอียด</div>

      <div class="row">
        <!-- <div class="col-lg-4">
              <base-input
                :label="$t('lmg.insure_year')"
                :value="detail.InsuranceYear"
                rules="required"
                :name="$t('lmg.insure_year')"
              ></base-input>
            </div>

            <div class="col-lg-4">
              <base-input
                :label="$t('lmg.trans_detail')"
                :value="detail.Detail"
                rules="required"
                :name="$t('lmg.trans_detail')"
              ></base-input>
            </div> -->

        <div class="col-lg-12">
          <label class="form-control-label">{{ $t('lmg.policy_number') }}</label>
          <div v-if="!editingPolicyNumber" class="d-flex align-items-center">
            <input class="form-control" readonly :value="detail.PolicyNumber" />
            <base-button
              size="sm"
              type="link"
              class="ml-1 px-2"
              :title="$t('lmg.edit')"
              @click="beginEditPolicyNumber()"
            >
              <i class="fas fa-edit"></i>
            </base-button>
          </div>
          <div v-else class="d-flex align-items-center">
            <input
              class="form-control"
              v-model="editPolicyNumber"
              :disabled="savingPolicyNumber"
              @keyup.enter="savePolicyNumber()"
              @keyup.esc="cancelEditPolicyNumber()"
            />
            <base-button
              size="sm"
              type="success"
              class="ml-1 px-2"
              :disabled="savingPolicyNumber"
              @click="savePolicyNumber()"
            >
              <i class="fas fa-spinner fa-spin" v-if="savingPolicyNumber"></i>
              <i class="fas fa-check" v-else></i>
            </base-button>
            <base-button
              size="sm"
              type="link"
              class="ml-1 px-2"
              :disabled="savingPolicyNumber"
              @click="cancelEditPolicyNumber()"
            >
              <i class="fas fa-times"></i>
            </base-button>
          </div>
        </div>
      </div>

      <div class="row" v-if="detail.TransactionDataType == 1">
        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.car_model')"
            :name="$t('lmg.car_model')"
            rules="required"
            :value="detail.CarModel"
          ></base-input>
        </div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.chassis_number')"
            :name="$t('lmg.chassis_number')"
            rules="required"
            :value="detail.ChassisNumber"
          ></base-input>
        </div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.license_plate')"
            :name="$t('lmg.license_plate')"
            rules="required"
            :value="detail.LicencePlate"
          ></base-input>
        </div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.car_year')"
            :name="$t('lmg.car_year')"
            rules="required"
            :value="detail.CarRegisterYear"
          ></base-input>
        </div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>

		<div class="col-lg-2">
          <base-input
            :label="$t('lmg.car_type')"
            :name="$t('lmg.car_type')"
            rules="required"
            :value="CarTypeName(detail.Engine)"
          ></base-input>
        </div>
      </div>

      <div class="row" v-if="detail.TransactionDataType == 2">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_type')"
            :name="$t('lmg.insure_type')"
            rules="required"
            :value="detail.InsuranceTypeDesc"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_plan')"
            :name="$t('lmg.insure_plan')"
            rules="required"
            :value="detail.InsurancePlan"
          ></base-input>
        </div>

        <div class="col-lg-1">
          <base-input
            :label="$t('lmg.age')"
            :name="$t('lmg.age')"
            rules="required"
            :value="detail.CustomerAge"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.detail')"
            :name="$t('lmg.detail')"
            rules="required"
            :value="detail.Detail"
          ></base-input>
        </div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>
      </div>

      <!-- LINE 5 - dataType 3 -->
      <div class="row" v-if="detail.TransactionDataType == 3">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_type')"
            :name="$t('lmg.insure_type')"
            rules="required"
            :value="detail.InsuranceTypeDesc"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.billing_address')"
            :name="$t('lmg.billing_address')"
            rules="required"
            :value="detail.BuildingAddress"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.code_disaster')"
            :name="$t('lmg.code_disaster')"
            rules="required"
            :value="detail.CodeDisaster"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>
      </div>

      <!-- LINE 5 - dataType 4 -->
      <div class="row" v-if="detail.TransactionDataType == 4">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.car_model')"
            :name="$t('lmg.car_model')"
            rules="required"
            :value="detail.CarModel"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.chassis_number')"
            :name="$t('lmg.chassis_number')"
            rules="required"
            :value="detail.ChassisNumber"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.license_plate')"
            :name="$t('lmg.license_plate')"
            rules="required"
            :value="detail.LicencePlate"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>
        <div class="col-lg-12">
          <base-input
            :label="$t('lmg.insurance_scope')"
            :name="$t('lmg.insurance_scope')"
            rules="required"
            :value="detail.InsuranceScope"
          ></base-input>
        </div>
      </div>

      <div class="row" v-if="detail.TransactionDataType == 5">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_type')"
            :name="$t('lmg.insure_type')"
            rules="required"
            :value="detail.InsuranceTypeDesc"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_plan')"
            :name="$t('lmg.insure_plan')"
            rules="required"
            :value="detail.InsurancePlan"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.note')"
            :name="$t('lmg.note')"
            rules="required"
            :value="detail.Detail"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>
      </div>

      </div> <!-- /Section: Policy & Product Detail -->

      <!-- SECTION: Coverage & Status -->
      <div class="detail-section">
        <div class="detail-section-header"><i class="fas fa-calendar-alt"></i>ความคุ้มครองและสถานะ</div>

      <!-- start , end  note -->
      <div class="row">
        <div class="col-lg-6">
          <label class="form-control-label">{{ $t('lmg.protection_date') }}</label>
          <div v-if="!editingDates" class="d-flex align-items-center">
            <input class="form-control" readonly
              :value="detail.StartDateShow + '  ' + $t('to') + '  ' + detail.EndDateShow" />
            <base-button
              size="sm"
              type="link"
              class="ml-1 px-2"
              :title="$t('lmg.edit')"
              @click="beginEditDates()"
            >
              <i class="fas fa-edit"></i>
            </base-button>
          </div>
          <div v-else class="d-flex align-items-center flex-wrap">
            <flat-picker
              :config="{ allowInput: true }"
              class="form-control datepicker"
              v-model="editStartDate"
              :disabled="savingDates"
            ></flat-picker>
            <span class="mx-2">{{ $t('to') }}</span>
            <flat-picker
              :config="{ allowInput: true }"
              class="form-control datepicker"
              v-model="editEndDate"
              :disabled="savingDates"
            ></flat-picker>
            <base-button
              size="sm"
              type="success"
              class="ml-1 px-2"
              :disabled="savingDates"
              @click="saveDates()"
            >
              <i class="fas fa-spinner fa-spin" v-if="savingDates"></i>
              <i class="fas fa-check" v-else></i>
            </base-button>
            <base-button
              size="sm"
              type="link"
              class="ml-1 px-2"
              :disabled="savingDates"
              @click="cancelEditDates()"
            >
              <i class="fas fa-times"></i>
            </base-button>
          </div>
        </div>
        <div class="col-lg-3">
          <label class="form-control-label">{{ $t('status') }}</label>
          <div class="pt-1">
            <span class="status-pill status-pill--success" v-if="detail.Status == 1">
              <i class="fas fa-check-circle"></i>สำเร็จ
            </span>
            <span class="status-pill status-pill--processing" v-else-if="detail.Status == 2">
              <i class="fas fa-clock"></i>กำลังดำเนินการ
            </span>
            <span class="status-pill status-pill--danger" v-else-if="detail.Status == 3">
              <i class="fas fa-ban"></i>ยกเลิก
            </span>
            <span class="status-pill status-pill--muted" v-else>—</span>
          </div>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.trans_date')"
            :value="detail.CreatedAtShow"
          ></base-input>
        </div>
      </div>
      </div> <!-- /Section: Coverage & Status -->

      <!-- SECTION: Notes & Cash Status -->
      <div class="detail-section">
        <div class="detail-section-header"><i class="fas fa-sticky-note"></i>หมายเหตุและสถานะเงินสด</div>

      <!-- สถานะการเงิน / cash not clear -->
      <!-- created date / status -->
      <div class="row">
        <div class="col-lg-6">
          <base-input :label="$t('lmg.note')" :value="detail.Note"></base-input>
        </div>
        <div class="col-lg-3">
          <label class="form-control-label">{{ $t('lmg.cash_clear') }}</label>
          <div class="pt-1">
            <span class="status-pill status-pill--success" v-if="detail.CashClear == 1">
              <i class="fas fa-check-circle"></i>ไม่มีเงินสดค้างที่พนักงาน
            </span>
            <span class="status-pill status-pill--danger" v-else-if="detail.CashClear == 2">
              <i class="fas fa-exclamation-triangle"></i>มีเงินสดค้าง
            </span>
            <span class="status-pill status-pill--muted" v-else-if="detail.CashClear == 3">
              <i class="fas fa-money-bill-wave"></i>ไม่ใช้เงินสด ไม่มีเงินค้าง
            </span>
            <span class="status-pill status-pill--muted" v-else>—</span>
          </div>
        </div>
        <div class="col-lg-3" v-if="detail.CashClear == 2">
          <base-input
            :label="$t('lmg.cash_clear_amount')"
            :value="detail.CashNotClearAmount"
          ></base-input>
        </div>
      </div>
      </div> <!-- /Section: Notes & Cash Status -->

	</div> <!-- /.trans-detail -->

      <template slot="footer">
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showDetailModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

    <!-- ------------------------ Modal Payment ------------------------ -->
    <modal
      :show.sync="showPaymentTableModal"
      modal-classes="modal-secondary modal-lg"
    >
      <h1>{{ $t("menu.payment") }}</h1>
      <el-table
        :data="tablePayment"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
      >
        <!-- Record paidvia   note bank amount -->
        <el-table-column :label="$t('lmg.recorder')">
          <template slot-scope="{ row }">
            {{ row.RecordPersonFName }} {{ row.RecordPersonLName }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.amount')">
          <template slot-scope="{ row }">
            {{ FormatCurrency(row.Amount) }}
            <!-- {{ row.PayAmount }} -->
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.payment_method')">
          <template slot-scope="{ row }">
            {{ getPaymentMethodName(row.PaidVia) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lmg.cash_clear')" min-width="200">
          <template slot-scope="{ row }">
            {{ getCashClearName(row.CashClear) }}
            <br />
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="handleCashClear(row)"
              v-if="row.CashClear == 2"
            >
              นำส่งสาขา
            </button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lmg.trans_date')">
          <template slot-scope="{ row }">
            {{ row.CreatedAt }}
          </template>
        </el-table-column>
      </el-table>

      <template slot="footer">
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showPaymentTableModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>


	<!-- ------------------------ Modal Cancel Transaction ------------------------ -->
    <modal
      :show.sync="showCancelModal"
      modal-classes="modal-secondary modal"
    >
      <h1>{{ $t("lmg.cancel_trans") }}</h1>
	   <h3>{{ $t("lmg.transaction_id") }} : {{ detail.ID}}</h3>

	  <!-- effectdate -->
	  <div class="row">
		<div class="col-lg-4">
			<base-input
			:label="$t('lmg.effect_date')"
			:name="$t('lmg.effect_date')"
			rules="required"
			>
			<flat-picker
				slot-scope="{ focus, blur }"
				@on-open="focus"
				@on-close="blur"
				:config="{ allowInput: true }"
				:rules="{ required: true }"
				class="form-control datepicker"
				v-model="cancelParams.effect_date"
			>
			</flat-picker>
			</base-input>
		</div>
	  </div>

		<div class="row">
			<div class="col">
				<base-input
					:label="$t('lmg.note')"
					v-model="cancelParams.note"
				></base-input>
			</div>
		</div>


      <template slot="footer">
		 <button
          type="button"
          class="btn btn-md btn-primary"
          @click="CancelTransaction()"
		  v-if="cancelParams.effect_date != ''"
        >
          {{ $t("save") }}
        </button>

        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showCancelModal = false;showDetailModal=false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

    <!-- ------------------------ Modal Billing ------------------------ -->
    <modal
      :show.sync="showBillingModal"
      modal-classes="modal-secondary modal-lg"
    >
      <h1>{{ $t("menu.billing") }}</h1>
      <el-table
        :data="tableBilling"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
      >
        <!-- Record paidvia   note bank amount -->
        <el-table-column :label="$t('lmg.recorder')">
          <template slot-scope="{ row }">
            {{ row.OwnerFName }} {{ row.OwnerLName }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.tel')">
          <template slot-scope="{ row }">
            {{ row.OwnerTel }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.amount')">
          <template slot-scope="{ row }">
            <!-- {{ row.Amount }} -->
            {{ FormatCurrency(row.PayAmount) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lmg.due_date')">
          <template slot-scope="{ row }">
            {{ row.DueDate }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('status')">
          <template slot-scope="{ row }">
            {{ getBillingStatusName(row.Paid) }}
            <template v-if="row.Paid == 2">
              <base-button
                @click.native="handleBillingPayment($index, row)"
                class="edit"
                type="warning"
                size="sm"
                icon
              >
                <i class="fas fa-dollar-sign"></i>
              </base-button>
              <!-- pay button -->
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showBillingModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

    <!-- ----------------------- Modal Cash Clear ------------------------->
    <modal
      :show.sync="showCashClearModal"
      modal-classes="modal-secondary modal-lg"
    >
      <h1>{{ $t("lmg.cash_clear_title") }}</h1>

      <div class="row">
        <div class="col-lg-12">
          <base-input
            :label="$t('lmg.note')"
            v-model="cash_clear.note"
          ></base-input>
        </div>
      </div>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleCreateCashClear()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showCashClearModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

    <!-- ------------------------ Modal Payment Form ------------------------ -->
    <modal
      :show.sync="showPaymentFormModal"
      modal-classes="modal-secondary modal-lg"
    >
      <h1>{{ $t("lmg.payment_create") }}</h1>
      <base-input
        :label="$t('lmg.trans_payment_amount')"
        :value="payment_form.amount"
        v-if="payment_form.billID != 0"
      ></base-input>
      <base-input
        :label="$t('lmg.trans_payment_amount')"
        v-model="payment_form.amount"
        v-if="payment_form.billID == 0"
      ></base-input>

      <base-input
        :label="$t('lmg.moreDiscount')"
        :value="payment_form.moreDiscount"
      ></base-input>

      <base-input
        :label="$t('lmg.billing_paid_via')"
        input-classes="form-control-alternative new-event--title"
      >
        <el-select
          v-model="payment_form.paidVia"
          :placeholder="$t('lmg.billing_paid_via')"
        >
          <el-option
            v-for="option in getPaymentMethod"
            :key="option.ID"
            :label="option.Name"
            :value="option.ID"
          >
          </el-option>
        </el-select>
      </base-input>

      <base-input
        :label="$t('lmg.bank')"
        input-classes="form-control-alternative new-event--title"
        v-if="payment_form.paidVia == 3"
      >
        <el-select v-model="payment_form.bankID" :placeholder="$t('lmg.bank')">
          <el-option
            v-for="option in tableBank"
            :key="option.ID"
            :label="option.Name"
            :value="option.ID"
          >
          </el-option>
        </el-select>
      </base-input>
      <base-input
        :label="$t('lmg.billing_note')"
        v-model="payment_form.note"
      ></base-input>

      <form>
        <base-input
          :label="$t('lmg.paid_file')"
          input-classes="form-control-alternative new-event--title"
        >
          <file-input @change="filesPaymentFormChange"></file-input>
        </base-input>
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleCreatePayment()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showPaymentFormModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

    <!-- ------------------------ Modal Report ------------------------ -->
    <modal
      :show.sync="showReportModal"
      modal-classes="modal-secondary modal-lg"
    >
      <h1>{{ $t("lmg.trans_report") }}</h1>

      <base-input
        :label="$t('lmg.discount')"
        input-classes="form-control-alternative new-event--title"
      >
        <el-select
          v-model="trans_report.discount"
          :placeholder="$t('lmg.bank')"
        >
          <el-option
            v-for="option in tableDiscount"
            :key="option.ID"
            :label="option.Name"
            :value="option.ID"
          >
          </el-option>
        </el-select>
      </base-input>
      <button class="btn btn-md btn-primary" @click="handleDiscountReport()">
        {{ $t("download") }}
      </button>

      <button v-if="detail.TaxAmount  > 0" class="btn btn-md btn-primary" @click="handleTaxReport()">
        {{ $t("download") }} ภาษีส่วนลด
      </button>

      <template slot="footer">
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showReportModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import * as XLSX from "xlsx";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    flatPicker,
    FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },

  data() {
    return {
      propsToSearch: ["Email", "Name"],
      selectedRows: [],
      searchParams: {
        startDate: "",
        endDate: "",
        sort: 1, //1=DESC
        status: 0, // 0 all, 1 เสร็จ, 2 กำลังดำเนินงาน
        insuranceID: 0, // insureanid
        cashClear: 0, //  0 all, 1 ไม่มีเงินสดค้างที่พนักงาน, 2 มีเงินสดค้าง, 3 ไม่ใช่เงินสด ไม่มีเงินค้าง
        policyNumber:"",
        ownerPersonID: 0, // 0 = ทั้งหมด
      },

      showCancelModal: false,
      showCreateModal: false,
      showDetailModal: false,
      showPaymentFormModal: false,
      showPaymentTableModal: false,
      showBillingModal: false,
      showCashClearModal: false,
      showReportModal: false,

      isSaveContinue: false,
      showSaveContinue: false,

      saveTransactionID: 0,

      detail: {},
      cash_clear: {
        paymentID: 0,
        note: ""
      },

      // Inline edit state for the transaction detail modal.
      editingPolicyNumber: false,
      editPolicyNumber: "",
      savingPolicyNumber: false,
      editingDates: false,
      editStartDate: "",
      editEndDate: "",
      savingDates: false,

	  cancelParams:{
		effect_date : "",
		note : "",
	  },

      ttype: "",
      trans: {
        transactionUpperID: "",
        ownerPersonID: "",
        comProfileID: "",
        insuranceID: "",
        amount: "",
        initialCom: "",
        initialPayment: "",
        initialPaymentVia: "",
        paymentBankID: "",
        policyNumber: "",
        licencePlate: "",
        startDate: "",
        endDate: "",
        customerID: "",
        customerCardNumber: "",
        customerFname: "",
        customerLname: "",
        customerPrefix: "",
        customerGender: "",
        customerDateOfBirth: "",
        customerTel: "",
        customerEmail: "",
        idCardType: "",
        note: "",
        nBilling: "",
        tfimg: "",
        incentive: "",
        commCalculate: "",
        transactionDataType: 1,

        insureDataType: 1,
        carModel: "",
        carRegisterYear: "",
        sumInsured: "",
        buildingAddress: "",
        chassisNumber: "",
        codeDisaster: "",
        insuranceScope: "",
        insurancePlan: "",
        customerAge: "",
        detail: "",
        insuranceYear: "",
        insuranceTypeDesc: "",
        saleDate: "",

        amountAll: "",
        commisionPercent: "",
        commisionAmount: "",
        taxAmount: "",
        taxPercent: "",
        netAmount: "",
        payAmount: "",
        billCharge: "",
        renew: 1,
        policyNumberUpper: "",
        moreDiscount: "",
        whTax: "",


		extraCharge:"",
		customerAddress:"",
		customerSubDistrictID:"",
		customerSubDistrict:"",
		customerDistrictID:"",
		customerDistrict:"",
		customerProvinceID:"",
		customerProvince:"",
		customerPostCode:"",
		engine:1,
      },
      payment_form: {
        tID: 0,
        amount: 0,
        paidVia: 1, //payment type
        billID: 0,
        bankID: 0,
        note: "",
        tfimg: null,
        moreDiscount:0,
      },
      payment_table: {},
      billing_table: {},
      trans_report: {
        discount: 5
      },
      tableDiscount: [
        { ID: 5, Name: "5%" },
        { ID: 6, Name: "6%" },
        { ID: 7, Name: "7%" },
        { ID: 8, Name: "8%" },
        { ID: 9, Name: "9%" },
        { ID: 10, Name: "10%" },
        { ID: 11, Name: "11%" },
        { ID: 12, Name: "12%" },
        { ID: 13, Name: "13%" },
        { ID: 14, Name: "14%" },
        { ID: 15, Name: "15%" },
        { ID: 16, Name: "16%" },
        { ID: 17, Name: "17%" },
        { ID: 18, Name: "18%" },
        { ID: 19, Name: "19%" },
        { ID: 20, Name: "20%" },
        { ID: 21, Name: "21%" }
      ],
      status: [
        { ID: 0, Name: "ทั้งหมด" },
        { ID: 1, Name: "สำเร็จ" },
        { ID: 2, Name: "กำลังดำเนินการ" }
      ],
      sort: [
        { ID: 0, Name: "เรียงตามวันที่ล่าสุด" },
        { ID: 1, Name: "เรียงตามวันที่เริ่มต้น" }
      ],
      cashClear: [
        { ID: 0, Name: "ทั้งหมด" },
        { ID: 1, Name: "ไม่มีเงินสดค้างที่พนักงาน" },
        { ID: 2, Name: "มีเงินสดคงค้างที่พนักงาน" },
        { ID: 3, Name: "ไม่ใช้เงินสด ไม่มีเงินค้าง" }
      ],
      paymentType: [
        { ID: 1, Name: "เงินสด" },
        { ID: 2, Name: "เช็ค" },
        { ID: 3, Name: "โอนเงิน" },
        { ID: 4, Name: "เงินสำรองจ่าย" },
        { ID: 5, Name: "บัตรเครดิต" }
      ],
	  carType: [
        { ID: 1, Name: "รถยนต์ทั่วไป" },
        { ID: 2, Name: "รถยนต์ไฟฟ้า" },
      ],
      pname: [
        { ID: 0, Name: "ไม่ระบุ" ,Group: 1},
        { ID: 1, Name: "ด.ช." ,Group: 1},
        { ID: 2, Name: "ด.ญ." ,Group: 1},
        { ID: 3, Name: "นาย" ,Group: 1},
        { ID: 4, Name: "นางสาว" ,Group: 1},
        { ID: 5, Name: "นาง" ,Group: 1},
        { ID: 6, Name: "คุณ" ,Group: 1},
        { ID: 7, Name: "Miss" ,Group: 2},
        { ID: 8, Name: "MR" ,Group: 2},
        { ID: 9, Name: "MRS" ,Group: 2},
        { ID: 10, Name: "MS" ,Group: 2},
        { ID: 11, Name: "Master" ,Group: 2},
        { ID: 12, Name: "หจก." ,Group: 3},
        { ID: 13, Name: "บจก.",Group: 3 },
        { ID: 14, Name: "สำนัก",Group: 3 }
      ],
      gender: [
        { ID: 1, Name: "ชาย" },
        { ID: 2, Name: "หญิง" },
        { ID: 3, Name: "ไม่ระบุ" }
      ],
      billingPeriod: [
        { ID: 1, Name: "1" },
        { ID: 3, Name: "3" }
      ],
      renewTable: [
        { ID: 1, Name: "ซื้อประกันใหม่" },
        { ID: 2, Name: "ต่ออายุ" }
      ],
      insureDataType: [
        { ID: 1, Name: this.$t("lmg.insure_data_type_1") },
        { ID: 2, Name: this.$t("lmg.insure_data_type_2") },
        { ID: 3, Name: this.$t("lmg.insure_data_type_3") },
        { ID: 3, Name: this.$t("lmg.insure_data_type_4") },
        { ID: 3, Name: this.$t("lmg.insure_data_type_5") }
      ],
      // insureDataType: [
      //   { ID: 3, Name: this.$t("lmg.insure_data_type_3") },
      //   { ID: 4, Name: this.$t("lmg.insure_data_type_4") }
      // ],
      idCardType: [
        { ID: 1, Name: this.$t("lmg.card_type_1") },
        { ID: 2, Name: this.$t("lmg.card_type_2") },
        { ID: 3, Name: this.$t("lmg.card_type_3") }
      ]
    };
  },
  watch: {
	
    "trans.customerCardNumber": {
      handler: function(val, oldVal) {
        //  this.foo(); // call it in the context of your component object
        if (val.length > 8) {
          this.checkCustomer({
            idCardType: this.trans.idCardType,
            idCardNumber: val
          }).then(res => {
            if (res.data.Data != null) {
              let d = res.data.Data[0];

              this.trans.customerID = d.ID;
              this.trans.customerDateOfBirth = d.DateOfBirth;
              this.trans.customerEmail = d.Email;
              this.trans.customerGender = d.Gender;
              this.trans.customerFname = d.FName;
              this.trans.customerLname = d.LName;
              this.trans.customerPrefix = d.PrefixName;
              this.trans.customerTel = d.Tel;

			//   list district
			// list subdistrict
			this.listDistrict({province_code : d.ProvinceID })
			this.listSubDistrict({district_code : d.DistrictID })

			  this.trans.customerAddress = d.Address
			  this.trans.customerProvinceID = d.ProvinceID
			  this.trans.customerSubDistrictID = d.SubDistrictID
			  this.trans.customerDistrictID = d.DistrictID
			  this.trans.customerPostCode = d.PostCode
            } else {
              this.trans.customerID = 0;
            }
          });
        }
      },
      deep: true
    },

    "trans.amount": {
      handler: function(val, oldVal) {
        if (
          this.transhowinsuranceID == "" ||
          this.trans.amount == "" ||
          this.trans.amountAll == "" ||
          this.trans.ownerPersonID == 0 
        )
          return;
        this.CalCommision({
          insuranceID: this.trans.insuranceID,
          ownerPersonID: this.trans.ownerPersonID,
          amount: this.trans.amount,
          amountAll: this.trans.amountAll,
          whTax : this.trans.whTax,
          moreDiscount : this.trans.moreDiscount,
          extraCharge : this.trans.extraCharge
        })
          .then(res => {
            this.trans.commisionAmount = res.data.Data[0].CommissionAmount;
            this.trans.commisionPercent = res.data.Data[0].CommissionPercent;
            this.trans.netAmount = res.data.Data[0].NetAmount;
            this.trans.taxAmount = res.data.Data[0].TaxAmount;
            this.trans.payAmount = res.data.Data[0].PayAmount;
            this.trans.taxPercent = res.data.Data[0].TaxPercent;
          })
          .catch(err => {
            this.trans.commCalculate = "";
          });
      },
      deep: true
    },
    "trans.insuranceID": {
      handler: function(val, oldVal) {
        if (this.trans.insuranceID != "") {
          this.trans.tableInsuretransactionDataType = 1;
          let tmp = this.tableInsure.filter(i => {
            return i.ID == this.trans.insuranceID;
          });
          if (tmp != null) {
            this.trans.transactionDataType = tmp[0].DataType;
          }
        }

        if (
          this.trans.insuranceID == "" ||
          this.trans.amount == "" ||
          this.trans.amountAll == "" ||
          this.trans.ownerPersonID == 0 
        )
          return;

        this.CalCommision({
          insuranceID: this.trans.insuranceID,
          ownerPersonID: this.trans.ownerPersonID,
          amount: this.trans.amount,
          amountAll: this.trans.amountAll,
          whTax : this.trans.whTax,
          moreDiscount : this.trans.moreDiscount,
          extraCharge : this.trans.extraCharge
        })
          .then(res => {
            this.trans.commisionAmount = res.data.Data[0].CommissionAmount;
            this.trans.commisionPercent = res.data.Data[0].CommissionPercent;
            this.trans.netAmount = res.data.Data[0].NetAmount;
            this.trans.taxAmount = res.data.Data[0].TaxAmount;
            this.trans.payAmount = res.data.Data[0].PayAmount;
            this.trans.taxPercent = res.data.Data[0].TaxPercent;
          })
          .catch(err => {
            this.trans.commCalculate = "";
          });
      },
      deep: true
    },
    "trans.ownerPersonID": {
      handler: function(val, oldVal) {
        if (
          this.trans.insuranceID == "" ||
          this.trans.amount == "" ||
          this.trans.amountAll == "" ||
          this.trans.ownerPersonID == 0 
        )
          return;
        this.CalCommision({
          insuranceID: this.trans.insuranceID,
          ownerPersonID: this.trans.ownerPersonID,
          amount: this.trans.amount,
          amountAll: this.trans.amountAll,
          whTax : this.trans.whTax,
          moreDiscount : this.trans.moreDiscount,
          extraCharge : this.trans.extraCharge
        })
          .then(res => {
            this.trans.commisionAmount = res.data.Data[0].CommissionAmount;
            this.trans.commisionPercent = res.data.Data[0].CommissionPercent;
            this.trans.netAmount = res.data.Data[0].NetAmount;
            this.trans.taxAmount = res.data.Data[0].TaxAmount;
            this.trans.payAmount = res.data.Data[0].PayAmount;
            this.trans.taxPercent = res.data.Data[0].TaxPercent;
          })
          .catch(err => {
            this.trans.commCalculate = "";
          });
      },
      deep: true
    },
    "trans.amountAll": {
      handler: function(val, oldVal) {
        if (
          this.trans.insuranceID == "" ||
          this.trans.amount == "" ||
          this.trans.amountAll == "" ||
          this.trans.ownerPersonID == 0
        )
          return;
        this.CalCommision({
          insuranceID: this.trans.insuranceID,
          ownerPersonID: this.trans.ownerPersonID,
          amount: this.trans.amount,
          amountAll: this.trans.amountAll,
          whTax : this.trans.whTax,
          moreDiscount : this.trans.moreDiscount,
          extraCharge : this.trans.extraCharge
        })
          .then(res => {
            this.trans.commisionAmount = res.data.Data[0].CommissionAmount;
            this.trans.commisionPercent = res.data.Data[0].CommissionPercent;
            this.trans.netAmount = res.data.Data[0].NetAmount;
            this.trans.taxAmount = res.data.Data[0].TaxAmount;
            this.trans.payAmount = res.data.Data[0].PayAmount;
            this.trans.taxPercent = res.data.Data[0].TaxPercent;
          })
          .catch(err => {
            this.trans.commCalculate = "";
          });
      },
      deep: true
    },
    "trans.whTax": {
      handler: function(val, oldVal) {
        if (
          this.trans.insuranceID == "" ||
          this.trans.amount == "" ||
          this.trans.amountAll == "" ||
          this.trans.ownerPersonID == 0 
        )
          return;
        this.CalCommision({
          insuranceID: this.trans.insuranceID,
          ownerPersonID: this.trans.ownerPersonID,
          amount: this.trans.amount,
          amountAll: this.trans.amountAll,
          whTax : this.trans.whTax,
          moreDiscount : this.trans.moreDiscount,
          extraCharge : this.trans.extraCharge
        })
          .then(res => {
            this.trans.commisionAmount = res.data.Data[0].CommissionAmount;
            this.trans.commisionPercent = res.data.Data[0].CommissionPercent;
            this.trans.netAmount = res.data.Data[0].NetAmount;
            this.trans.taxAmount = res.data.Data[0].TaxAmount;
            this.trans.payAmount = res.data.Data[0].PayAmount;
            this.trans.taxPercent = res.data.Data[0].TaxPercent;
          })
          .catch(err => {
            this.trans.commCalculate = "";
          });
      },
      deep: true
    },
    "trans.moreDiscount": {
      handler: function(val, oldVal) {
        if (
          this.trans.insuranceID == "" ||
          this.trans.amount == "" ||
          this.trans.amountAll == "" ||
          this.trans.ownerPersonID == 0 
        )
          return;
        this.CalCommision({
          insuranceID: this.trans.insuranceID,
          ownerPersonID: this.trans.ownerPersonID,
          amount: this.trans.amount,
          amountAll: this.trans.amountAll,
          whTax : this.trans.whTax,
          moreDiscount : this.trans.moreDiscount,
          extraCharge : this.trans.extraCharge
        })
          .then(res => {
            this.trans.commisionAmount = res.data.Data[0].CommissionAmount;
            this.trans.commisionPercent = res.data.Data[0].CommissionPercent;
            this.trans.netAmount = res.data.Data[0].NetAmount;
            this.trans.taxAmount = res.data.Data[0].TaxAmount;
            this.trans.payAmount = res.data.Data[0].PayAmount;
            this.trans.taxPercent = res.data.Data[0].TaxPercent;
          })
          .catch(err => {
            this.trans.commCalculate = "";
          });
      },
      deep: true
    },
    "trans.extraCharge": {
      handler: function(val, oldVal) {
        if (
          this.transhowinsuranceID == "" ||
          this.trans.amount == "" ||
          this.trans.amountAll == "" ||
          this.trans.ownerPersonID == 0 
        )
          return;
        this.CalCommision({
          insuranceID: this.trans.insuranceID,
          ownerPersonID: this.trans.ownerPersonID,
          amount: this.trans.amount,
          amountAll: this.trans.amountAll,
          whTax : this.trans.whTax,
          moreDiscount : this.trans.moreDiscount,
          extraCharge : this.trans.extraCharge
        })
          .then(res => {
            this.trans.commisionAmount = res.data.Data[0].CommissionAmount;
            this.trans.commisionPercent = res.data.Data[0].CommissionPercent;
            this.trans.netAmount = res.data.Data[0].NetAmount;
            this.trans.taxAmount = res.data.Data[0].TaxAmount;
            this.trans.payAmount = res.data.Data[0].PayAmount;
            this.trans.taxPercent = res.data.Data[0].TaxPercent;
          })
          .catch(err => {
            this.trans.commCalculate = "";
          });
      },
      deep: true
    },
  },
  async mounted() {
    this.searchParams.startDate = this.getStartDate();
    this.searchParams.endDate = this.getEndDate();
    this.trans.saleDate = this.getEndDate();
    // Allow callers (e.g. invoice detail modal) to deep-link a policy number:
    // /lmg/transaction?policyNumber=XYZ pre-fills the search before listing.
    if (this.$route.query.policyNumber) {
      this.searchParams.policyNumber = this.$route.query.policyNumber;
    }
    await this.listInsure();
    await this.listComm();
    this.listPerson();
    this.listPersonDropdown();
    this.listBank();
    this.listTtype();
    this.clearCreate();
    this.listData(this.searchParams);
	this.listProvince();
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "Transaction/getData",
      tableInsure: "Insure/getData",
      tablePerson: "Person/getData",
      tableComm: "Comm/getData",
      tableCommWithAll: "Comm/getDataWithAll",
      tableInsureWithAll: "Insure/getDataWithAll",
      tablePersonDropdownWithAll: "Person/getDataDropdownWithAll",
      tableBank: "Bank/getData",
      tablePayment: "Payment/getData",
      tableBilling: "Billing/getData",
      tableTtype: "Ttype/getData",
      getPaymentMethod: "Payment/getPaymentMethodTable",
      getPaymentMethodName: "Payment/getPaymentMethodName",
      getCashClearName: "Payment/getCashClearName",
      getBillingStatusName: "Billing/getBillingStatusName",

	  ProvinceTable:"Address/getProvince",
	  DistrictTable:"Address/getDistrict",
	  SubDistrictTable:"Address/getSubDistrict",
	  isLoading:"Transaction/isLoading"
    }),
    tablePname(){
      if (this.trans.idCardType == "") return this.pname
      return this.pname.filter(p=>{
        return p.Group == this.trans.idCardType
      })
    },
    tableData: function() {
      return this.tableDataOrg;
    },
    customerCardNumber() {
      return this.trans.customerCardNumber;
    },
    tablePersonFilter() {
      if (this.ttype != 0 && this.ttype != "") {
        return this.tablePerson.filter(v => {
          return v.UserTypeID == this.ttype;
        });
      }

      return this.tablePerson;
    },
    getTaxPercent() {
      if (this.trans.taxPercent == "") return this.$t('lmg.tax_amount');
      else return this.$t('lmg.tax_amount') + " " + this.trans.taxPercent + " %";
    },
    getCommissionPercent() {
      if (this.trans.commisionPercent == "") return this.$t('lmg.commission_discount');
      else return this.$t('lmg.commission_discount') + " " + this.trans.commisionPercent + " %";
    }
  },
  methods: {
    ...mapActions({
      createData: "Transaction/createData",
      createCashClear: "Payment/createClear",
      listData: "Transaction/listData",
      listInsure: "Insure/listData",
      listPerson: "Person/listData",
      listPersonDropdown: "Person/listDropdown",
      listComm: "Comm/listData",
      listBank: "Bank/listData",
      listPayment: "Payment/listData",
      listTtype: "Ttype/listData",
      createPayment: "Payment/createData",
      createBillingPayment: "Billing/createData",
      listBilling: "Billing/listData",
      checkCustomer: "Customer/checkID",
      getReportDiscount: "Transaction/ReportDiscount",
      getReporTaxDiscount: "Transaction/ReportTaxDiscount",


      listProvince: "Address/listProvince",
      listDistrict: "Address/listDistrict",
      listSubDistrict: "Address/listSubDistrict",
	  
      CalCommision: "Transaction/CalCommision",
	  cancelData: "Transaction/cancelData",
	  updatePolicyNumberAction: "Transaction/updatePolicyNumber",
	  updateDateAction: "Transaction/updateDate"
    }),
    clearPayment() {
      this.payment_form.tID = 0;
      this.payment_form.amount = "";
      this.payment_form.paidVia = 1;
      this.payment_form.billID = 0;
      this.payment_form.bankID = 0;
      this.payment_form.note = "";
      this.payment_form.moreDiscount = "";
      this.payment_form.tfimg = null;
    },
    clearCreateContinue() {
      this.trans.insuranceTypeDesc = "";
      this.trans.amount = "";
      this.trans.initialCom = "";
      this.trans.initialPayment = "";
      this.trans.initialPaymentVia = "";
      this.trans.tfimg = "";
      this.trans.incentive = "";
      this.trans.policyNumber = "";
      this.trans.moreDiscount = "";
    },
    clearCreate() {
      this.trans.initialCom = "";
      this.trans.initialPayment = "";
      this.trans.initialPaymentVia = "";
      this.trans.paymentBankID = "";
      this.trans.policyNumber = "";
      this.trans.licencePlate = "";
      this.trans.startDate = "";
      this.trans.endDate = "";
      this.trans.customerID = 0;
      this.trans.customerCardNumber = "";
      this.trans.customerFname = "";
      this.trans.customerLname = "";
      this.trans.customerPrefix = "";
      this.trans.customerGender = "";
      this.trans.customerDateOfBirth = "";
      this.trans.customerTel = "";
      this.trans.customerEmail = "";
      this.trans.note = "";
      this.trans.nBilling = 1;
      this.trans.tfimg = "";
      this.trans.incentive = "";
      this.trans.transactionDataType = 3;
      this.trans.detail = "";
      this.trans.carModel = "";
      this.trans.carRegisterYear = "";
      this.trans.sumInsured = "";
      this.trans.buildingAddress = "";
      this.trans.chassisNumber = "";
      this.trans.codeDisaster = "";
      this.trans.insuranceScope = "";
      this.trans.insurancePlan = "";
      this.trans.customerAge = "";
      this.trans.detail = "";
      this.trans.insuranceYear = "";
      this.trans.insuranceTypeDesc = "";
      this.trans.amountAll = "";
      this.trans.commisionAmount = "";
      this.trans.taxAmount = "";
      this.trans.netAmount = "";
      this.trans.payAmount = "";
      this.trans.billCharge = "";
      this.trans.renew = 1;
      this.trans.policyNumberUpper = "";
      this.trans.moreDiscount = "";
      this.trans.whTax = "";

	  this.trans.customerAddress ="";
	  this.trans.customerSubDistrictID ="";
	  this.trans.customerSubDistrict ="";
	  this.trans.customerDistrictID ="";
	  this.trans.customerDistrict ="";
	  this.trans.customerProvinceID ="";
	  this.trans.customerProvince ="";
	  this.trans.customerPostCode ="";
    },
    handleSaveContinue() {
      this.isSaveContinue = true;
    },
    handleCreate() {
      this.showCreateModal = true;
      this.showSaveContinue = true;
      this.isSaveContinue = false;
      this.trans.transactionUpperID = "";
    },
    handleCreateRequest() {
      let form = new FormData();
      form.append("ownerPersonID", this.trans.ownerPersonID);
      // form.append("comProfileID", this.trans.comProfileID);
      form.append("insuranceID", this.trans.insuranceID);
      form.append("amount", this.trans.amount);
      form.append("initialCom", this.trans.initialCom);
      form.append("initialPayment", this.trans.initialPayment);
      form.append("initialPaymentVia", this.trans.initialPaymentVia);
      form.append("paymentBankID", this.trans.paymentBankID);
      form.append("policyNumber", this.trans.policyNumber);
      form.append("licencePlate", this.trans.licencePlate);
      form.append("startDate", this.trans.startDate);
      form.append("endDate", this.trans.endDate);
      form.append("customerID", this.trans.customerID);
      form.append("idCardType", this.trans.idCardType);
      form.append("customerCardNumber", this.trans.customerCardNumber);
      form.append("customerFname", this.trans.customerFname);
      form.append("customerLname", this.trans.customerLname);
      form.append("customerPrefix", this.trans.customerPrefix);
      form.append("customerGender", this.trans.customerGender);
      form.append("customerDateOfBirth", this.trans.customerDateOfBirth);
      form.append("customerTel", this.trans.customerTel);
      form.append("customerEmail", this.trans.customerEmail);
      form.append("note", this.trans.note);
      form.append("saleDate", this.trans.saleDate);

      form.append("transactionDataType", this.trans.transactionDataType);
      form.append("carModel", this.trans.carModel);
      form.append("carRegisterYear", this.trans.carRegisterYear);
      form.append("sumInsured", this.trans.sumInsured);
      form.append("buildingAddress", this.trans.buildingAddress);
      form.append("chassisNumber", this.trans.chassisNumber);
      form.append("codeDisaster", this.trans.codeDisaster);
      form.append("insuranceScope", this.trans.insuranceScope);
      form.append("insurancePlan", this.trans.insurancePlan);
      form.append("customerAge", this.trans.customerAge);
      // form.append("detail", this.trans.detail);
      // form.append("insuranceYear", this.trans.insuranceYear);
      form.append("insuranceTypeDesc", this.trans.insuranceTypeDesc);
      form.append("detail", "0");
      form.append("insuranceYear", "");

      form.append("transactionUpperID", this.trans.transactionUpperID);

      form.append("amountAll", this.trans.amountAll);
      form.append("commisionPercent", this.trans.commisionPercent);
      form.append("commisionAmount", this.trans.commisionAmount);
      form.append("taxPercent", this.trans.taxPercent);
      form.append("taxAmount", this.trans.taxAmount);
      form.append("netAmount", this.trans.netAmount);
      form.append("payAmount", this.trans.payAmount);
      form.append("billCharge", this.nBilling != 3 ? this.trans.billCharge : 0);
      form.append("renew", this.trans.renew);
      form.append("policyNumberUpper", this.trans.policyNumberUpper);
      form.append("moreDiscount", this.trans.moreDiscount);
      form.append("whTax", this.trans.whTax);
      form.append("engine", this.trans.engine);

      form.append(
        "nBilling",
        this.trans.initialPaymentVia == 4 ||
          this.trans.initialPayment == this.trans.amount
          ? 1
          : this.trans.nBilling
      );
      form.append("tfimg", this.trans.tfimg);
      form.append("incentive", this.trans.incentive);

	form.append("extraCharge",this.trans.extraCharge);
	//  Add Address
	form.append("customerAddress",this.trans.customerAddress);
	form.append("customerSubDistrictID",this.trans.customerSubDistrictID);
	form.append("customerSubDistrict",this.trans.customerSubDistrict);
	form.append("customerDistrictID",this.trans.customerDistrictID);
	form.append("customerDistrict",this.trans.customerDistrict);
	form.append("customerProvinceID",this.trans.customerProvinceID);
	form.append("customerProvince",this.trans.customerProvince);
	form.append("customerPostCode",this.trans.customerPostCode);




      this.createData(form)
        .then(resp => {
          this.listData(this.searchParams);

          swal.fire({
            title: this.$t("create_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });

          if (this.isSaveContinue == true) {
            this.trans.transactionUpperID = resp.data.Datum;
            this.showSaveContinue = false;
            this.isSaveContinue = false;
            this.clearCreateContinue();
          } else {
            this.showCreateModal = false;
            this.clearCreate();
          }
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleCashClear(row) {
      this.showCashClearModal = true;
      this.showPaymentModal = false;
      this.cash_clear.paymentID = row.ID;
      this.cash_clear.note = "";
    },
    handleCreateCashClear() {
      this.showPaymentFormModal = false;

      this.createCashClear(this.cash_clear)
        .then(resp => {
          this.showCashClearModal = false;
          this.listPayment({ tID: this.payment_form.tID });
          swal.fire({
            title: this.$t("edit_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleDetail(row) {
      this.detail = row;
      // Reset inline-edit state whenever a new row is opened so the modal
      // never appears already-in-edit mode from a previous row.
      this.editingPolicyNumber = false;
      this.editingDates = false;
      this.savingPolicyNumber = false;
      this.savingDates = false;
      this.showDetailModal = true;
    },

    beginEditPolicyNumber() {
      this.editPolicyNumber = this.detail.PolicyNumber || "";
      this.editingPolicyNumber = true;
    },
    cancelEditPolicyNumber() {
      this.editingPolicyNumber = false;
      this.editPolicyNumber = "";
    },
    async savePolicyNumber() {
      const next = (this.editPolicyNumber || "").trim();
      if (!next) {
        swal.fire({ icon: "warning", title: "กรุณาระบุหมายเลขกรมธรรม์", timer: 1500, showConfirmButton: false });
        return;
      }
      if (next === this.detail.PolicyNumber) {
        this.editingPolicyNumber = false;
        return;
      }
      this.savingPolicyNumber = true;
      try {
        await this.updatePolicyNumberAction({
          ID: this.detail.ID,
          policy_number: next,
        });
        this.detail.PolicyNumber = next;
        this.editingPolicyNumber = false;
        swal.fire({ icon: "success", title: this.$t("edit_success"), timer: 1200, showConfirmButton: false });
        this.listData(this.searchParams);
      } catch (err) {
        const key = err && err.response && err.response.data && err.response.data.Msg;
        swal.fire({ icon: "error", title: key ? this.$t(key) : this.$t("edit_fail") });
      } finally {
        this.savingPolicyNumber = false;
      }
    },

    beginEditDates() {
      this.editStartDate = this.parseToYMD(this.detail.StartDate) || this.parseShowToYMD(this.detail.StartDateShow);
      this.editEndDate = this.parseToYMD(this.detail.EndDate) || this.parseShowToYMD(this.detail.EndDateShow);
      this.editingDates = true;
    },
    cancelEditDates() {
      this.editingDates = false;
      this.editStartDate = "";
      this.editEndDate = "";
    },
    async saveDates() {
      if (!this.editStartDate || !this.editEndDate) {
        swal.fire({ icon: "warning", title: "กรุณาเลือกวันที่ให้ครบถ้วน", timer: 1500, showConfirmButton: false });
        return;
      }
      if (new Date(this.editEndDate) < new Date(this.editStartDate)) {
        swal.fire({ icon: "warning", title: "วันสิ้นสุดต้องไม่ก่อนวันเริ่มต้น", timer: 1800, showConfirmButton: false });
        return;
      }
      this.savingDates = true;
      try {
        await this.updateDateAction({
          ID: this.detail.ID,
          start_date: this.editStartDate,
          end_date: this.editEndDate,
        });
        this.editingDates = false;
        swal.fire({ icon: "success", title: this.$t("edit_success"), timer: 1200, showConfirmButton: false });
        this.listData(this.searchParams);
      } catch (err) {
        const key = err && err.response && err.response.data && err.response.data.Msg;
        swal.fire({ icon: "error", title: key ? this.$t(key) : this.$t("edit_fail") });
      } finally {
        this.savingDates = false;
      }
    },

    parseToYMD(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
    parseShowToYMD(value) {
      // StartDateShow / EndDateShow arrive as "dd/mm/yyyy" from FormatWithSlash.
      if (!value) return "";
      const parts = String(value).split("/");
      if (parts.length !== 3) return "";
      const [dd, mm, yyyy] = parts;
      if (!dd || !mm || !yyyy) return "";
      return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
    },
    handleReport(row) {
      this.detail = row;
      this.showReportModal = true;
    },

    handleDiscountReport() {
      this.getReportDiscount({
        tID: this.detail.ID,
        discountPercent: this.trans_report.discount
      })
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {});
    },
	handleTaxReport(){
      this.getReporTaxDiscount({
        TID: this.detail.ID,
      })
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {});

		
	},
    handlePaymentForm(row) {
      this.payment_form.tID = row.ID;
      // this.payment_form.amount = row.Amount;
      this.payment_form.amount = row.PayAmount;
      this.payment_form.bankID = this.tableBank[0].ID;

      this.showPaymentFormModal = true;
    },
    handlePaymentTable(index, row) {
      this.payment_form.tID = row.ID;
      this.listPayment({ tID: row.ID });
      this.showPaymentTableModal = true;
      // show payment
    },
    handleBilling(index, row) {
      // goto billing page
      this.detail = row;
      this.clearPayment();
      this.listBilling({ tID: row.ID });
      this.showBillingModal = true;
      this.payment_form.tID = row.ID;
    },
    handleBillingPayment(index, row) {
      // show payment from with bill id
      this.detail = row;
      this.showPaymentFormModal = true;
      this.payment_form.billID = row.ID;
      // this.payment_form.amount = row.Amount;
      this.payment_form.amount = row.PayAmount;
      this.payment_form.bankID = this.tableBank[0].ID;
    },
    handleCreatePayment() {
      this.showPaymentFormModal = false;

      let formData = new FormData();
      formData.append("tID", this.payment_form.tID);
      formData.append("billID", this.payment_form.billID);
      formData.append("paidVia", this.payment_form.paidVia);
      formData.append("note", this.payment_form.note);
      formData.append("tfimg", this.payment_form.billfile);
      formData.append("bankID", this.payment_form.bankID);
      // formData.append("moreDiscount", this.payment_form.moreDiscount);

      if (this.payment_form.billID == 0) {
        this.createPayment(formData)
          .then(resp => {
            this.listData(this.searchParams);
            this.listBilling({ tID: this.payment_form.tID });
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      } else {
        this.createBillingPayment(formData)
          .then(resp => {
            this.listData(this.searchParams);
            this.listBilling({ tID: this.payment_form.tID });
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      }
    },
    handleTransactionPayment(index, row) {
      this.clearPayment();
      this.showPaymentFormModal = true;
      this.payment_form.tID = row.ID;
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    filesChange(files) {
      this.trans.tfimg = files[0];
    },
    filesPaymentFormChange(files) {
      this.payment_form.tfimg = files[0];
    },

	handleResetFilters() {
		this.searchParams.startDate = this.getStartDate();
		this.searchParams.endDate = this.getEndDate();
		this.searchParams.sort = 1;
		this.searchParams.status = 0;
		this.searchParams.insuranceID = 0;
		this.searchParams.ownerPersonID = 0;
		this.searchParams.cashClear = 0;
		this.searchParams.policyNumber = "";
		this.listData(this.searchParams);
	},

	// handleExport CSV
	handleExportCSV() {
		let header = {
		  SaleDate: "วันที่ขาย",
          PolicyNumber: "หมายเลขกรมธรรม์",
          OwnerPerson: "ตัวแทน",
          Customer: "ผู้เอาประกัน",
          InsuranceShowName: "ประเภทประกัน",
          StartDate: "วันที่เริ่มต้นคุ้มครอง",
          EndDate: "วันที่สินสุดคุ้มครอง",
          Amount: "เบี้ยสุทธิ",
          AmountAll: "เบี้ยรวม",
          CommissionAmount: "ส่วนลด",
          TaxAmount: "ภาษี",
		  Discount: "ส่วนลดพิเศษ",
		  PayAmount:"ยอดรวมชำระ",
		  Type:"ประเภท",
        }
		// getrenate csv from querydata
		

		let data = this.tableData.map(it => {
			return {
				SaleDate: it.SaleDate,
				PolicyNumber: it.PolicyNumber,
				OwnerPerson: it.OwnerPersonFName  + " " + it.OwnerPersonLName,
				Customer: it.CustomerFname + " " + it.CustomerLname,
				InsuranceShowName: it.InsuranceShowName,
				StartDate: it.StartDate,
				EndDate: it.EndDate,
				Amount: it.Amount,
				AmountAll: it.AmountAll,
				CommissionAmount: it.CommissionAmount,
				TaxAmount: it.TaxAmount,
				Discount: it.Discount,
				PayAmount: it.PayAmount,
				Type: it.Renew == 2 ? "ต่ออายุ" : "ซื้อประกันใหม่",
			};
		});

		// merge header and data
		let array = [header, ...data];

		let csvContent = array
			.map(it => {
			return Object.values(it).toString();
			})
			.join("\n");

		var universalBOM = "\uFEFF";
		var link = document.createElement("a");
		link.setAttribute(
			"href",
			"data:text/csv;charset=utf-8," +
			encodeURIComponent(universalBOM + csvContent)
		);
		link.setAttribute("download", "export.csv");
		document.body.appendChild(link);

		link.click();
	},

	// handleExport XLSX — same columns as CSV, Excel-native format.
	handleExportXLSX() {
		const columns = [
			{ key: "SaleDate",          label: "วันที่ขาย" },
			{ key: "PolicyNumber",      label: "หมายเลขกรมธรรม์" },
			{ key: "OwnerPerson",       label: "ตัวแทน" },
			{ key: "Customer",          label: "ผู้เอาประกัน" },
			{ key: "InsuranceShowName", label: "ประเภทประกัน" },
			{ key: "StartDate",         label: "วันที่เริ่มต้นคุ้มครอง" },
			{ key: "EndDate",           label: "วันที่สินสุดคุ้มครอง" },
			{ key: "Amount",            label: "เบี้ยสุทธิ" },
			{ key: "AmountAll",         label: "เบี้ยรวม" },
			{ key: "CommissionAmount",  label: "ส่วนลด" },
			{ key: "TaxAmount",         label: "ภาษี" },
			{ key: "Discount",          label: "ส่วนลดพิเศษ" },
			{ key: "PayAmount",         label: "ยอดรวมชำระ" },
			{ key: "Type",              label: "ประเภท" },
		];

		const rows = this.tableData.map(it => ({
			SaleDate:          it.SaleDate,
			PolicyNumber:      it.PolicyNumber,
			OwnerPerson:       (it.OwnerPersonFName || "") + " " + (it.OwnerPersonLName || ""),
			Customer:          (it.CustomerFname || "") + " " + (it.CustomerLname || ""),
			InsuranceShowName: it.InsuranceShowName,
			StartDate:         it.StartDate,
			EndDate:           it.EndDate,
			Amount:            it.Amount,
			AmountAll:         it.AmountAll,
			CommissionAmount:  it.CommissionAmount,
			TaxAmount:         it.TaxAmount,
			Discount:          it.Discount,
			PayAmount:         it.PayAmount,
			Type:              it.Renew == 2 ? "ต่ออายุ" : "ซื้อประกันใหม่",
		}));

		// Build the sheet as an array-of-arrays so we control the header row
		// text and column order (json_to_sheet would emit English keys).
		const header = columns.map(c => c.label);
		const body = rows.map(r => columns.map(c => r[c.key]));
		const ws = XLSX.utils.aoa_to_sheet([header, ...body]);

		// Set a reasonable column width so Thai headers are readable.
		ws["!cols"] = columns.map(c => ({ wch: Math.max(c.label.length + 2, 14) }));

		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Transactions");

		const today = new Date().toISOString().slice(0, 10);
		XLSX.writeFile(wb, `transactions_${today}.xlsx`);
	},
	handleProviceChange() {
		this.trans.customerDistrictID = ''
		this.trans.customerSubDistrictID = ''
		this.listDistrict({province_code : this.trans.customerProvinceID })
	},
	handleDistrictChange() {
		this.trans.customerSubDistrictID = ''
		this.listSubDistrict({district_code : this.trans.customerDistrictID })
	},
	handleSubDistrictChange() {
		let subdistrict = this.SubDistrictTable.filter((v)=>{
			return v.code == this.trans.customerSubDistrictID
		})

		if (subdistrict != null ){
			this.trans.customerPostCode =subdistrict[0].zip_code
		}

		
	},

	handleCancelTransaction(){
		this.showCancelModal = true		
		this.cancelParams.effect_date = this.getEndDate()
		this.cancelParams.note = ""
	},
	CancelTransaction(){

            this.cancelData({ 
				transaction_id: this.detail.ID ,
				effect_date : this.cancelParams.effect_date,
				note : this.cancelParams.note
			  })
              .then(resp => {
				this.showCancelModal = false;
				this.showDetailModal = false;

                this.listData(this.searchParams);
                swal.fire({
                  title: this.$t("cancel_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t("cancel_fail"),
                  text: this.$t(err.response.data.Msg),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
			  });
	},
	CarTypeName(id){
		let name = "-"

		this.carType.forEach((v=>{
			if (v.ID == id){
				name =  v.Name
			}
		}))


		return name 
	}


  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}

/* ---- Transaction detail modal styling ---- */
.trans-detail .detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  background: linear-gradient(135deg, #f5f7fb 0%, #ecf0fb 100%);
  border-left: 4px solid #5e72e4;
}
.trans-detail .detail-header h4 {
  margin: 0;
  font-weight: 600;
  color: #32325d;
}
.trans-detail .detail-header .detail-id {
  font-weight: 400;
  color: #8898aa;
  margin-left: 0.5rem;
}

.trans-detail .detail-section {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem 0.25rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 2px rgba(50, 50, 93, 0.04);
}
.trans-detail .detail-section-header {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8898aa;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed #e9ecef;
}
.trans-detail .detail-section-header i {
  margin-right: 0.5rem;
  color: #5e72e4;
  font-size: 0.9rem;
}
.trans-detail .detail-section--financial {
  background: #fafcff;
  border-color: #dfe7f5;
}
.trans-detail .detail-section--financial .detail-section-header i {
  color: #2dce89;
}

/* pill-style status badges */
.trans-detail .status-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.trans-detail .status-pill i {
  margin-right: 0.35rem;
}
.trans-detail .status-pill--success {
  background: #e6f8ef;
  color: #1aae6f;
}
.trans-detail .status-pill--processing {
  background: #fff4e0;
  color: #c58b00;
}
.trans-detail .status-pill--danger {
  background: #fde4e4;
  color: #d6436a;
}
.trans-detail .status-pill--muted {
  background: #eef1f7;
  color: #525f7f;
}

/* read-only inputs inside the modal feel more like display fields */
.trans-detail .form-control[readonly] {
  background-color: #fbfcfe;
  cursor: default;
}
</style>
